import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { TranslateModule } from "@ngx-translate/core";
import { isFunction } from "lodash-es";

import { _MAT_GLOBAL_CONFIG, MAT_GLOBAL_CONFIG } from "./const";
import { MatGlobalConfig } from "./model";

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		TranslateModule,
		MatMenuModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatInputModule,
	],
	exports: [],
	declarations: [],
})
export class MatGlobalModule {
	static forRoot(config?: MatGlobalConfig | (() => MatGlobalConfig)): ModuleWithProviders<MatGlobalModule> {
		return {
			ngModule: MatGlobalModule,
			providers: [
				{ provide: MAT_GLOBAL_CONFIG, useFactory: _globalConfigFactory, deps: [_MAT_GLOBAL_CONFIG] },
				{ provide: _MAT_GLOBAL_CONFIG, useValue: config },
			],
		};
	}
}

/**
 * @internal
 */
export function _globalConfigFactory(config?: MatGlobalConfig | (() => MatGlobalConfig)) {
	return isFunction(config) ? config() : config;
}
